import { approvalTypeList } from '@/constants';
// import BASE_API from '@/api/dataBase';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'storageCode',
      name: '三级编码',
      type: 'input',
    },
    {
      prop: 'storageName',
      name: '三级名称',
      type: 'input',
    },

    {
      prop: 'storageCreatePersonNo',
      name: '创建人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changeCreatePersonMethod,
    },
    {
      prop: 'currentStatus',
      name: '状态',
      type: 'select',
      options: approvalTypeList.filter((item) => ['ZT03', 'ZT04'].includes(item.value)),
    },
    // {
    //   prop: 'storageCompanyName',
    //   name: '所属组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   apiData: {
    //     tenantCode: ctx.userInfo.tenantCode,
    //     adminFlag: ctx.userInfo.adminFlag,
    //     selfCompanyDepartmentTreeFlag: true,
    //   },
    // },
    {
      prop: 'belongToLevel1Id',
      name: '所属一级',
      type: 'searchTableSpec',
      searchType: 'storageTableDialog',
      changeMethod: ctx.changeStorageTable1Method,
      isMultiple: true,
      extraData: {
        level: 1,
        parentId: '',
      },
    },
    {
      prop: 'belongToLevel2Id',
      name: '所属二级',
      type: 'searchTableSpec',
      searchType: 'storageTableDialog',
      changeMethod: ctx.changeStorageTable2Method,
      isMultiple: true,
      extraData: {
        level: 2,
        parentId: '',
      },
    },
    // {
    //   prop: 'storageType',
    //   name: '仓库类型',
    //   type: 'select',
    //   options: storeType,
    // },
  ];
};
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    field: 'storageCode',
    title: '三级编码',
    visible: true,
  },
  {
    field: 'storageName',
    title: '三级名称',
    visible: true,
  },
  {
    field: 'storageAddress',
    title: '仓库地址',
    visible: true,
  },
  {
    field: 'storageCompanyName',
    title: '所属组织',
    visible: true,
  },
  {
    field: 'belongToLevel1Name',
    title: '所属一级',
    visible: true,
  },
  {
    field: 'belongToLevel2Name',
    title: '所属二级',
    visible: true,
  },
  {
    field: 'storageCreatePersonName',
    title: '创建人',
    visible: true,
  },
  // {
  //   field: 'isSpecial',
  //   title: '是否专库',
  //   visible: true,
  // },
  {
    field: 'storageCreateTime',
    title: '创建时间',
    visible: true,
  },
  {
    field: 'currentStatus',
    title: '状态',
    visible: true,
  },
];
